import { connect } from 'react-redux';
import InspectionComment from './InspectionComment';
import { addInspectionCommentBegin } from '../../../../store/actions/inspection.actions';
import {
    getAddInspectionCommentLoader,
    getInspectionCommentList,
} from '../../../../store/selectors/inspection.selectors';
const mapStateToProps = (state: any) => {
    const loading = getAddInspectionCommentLoader(state);
    const inspectionCommentList = getInspectionCommentList(state);

    return {
        loading,
        inspectionCommentList,
    };
};

const mapDispatchToProps = {
    addInspectionComment: addInspectionCommentBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(InspectionComment);
